import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next'
import { createForm } from 'rc-form'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import CloseIcon from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography'

import { formatNumber } from 'libraries/utils'

const ViewWineNoteDialog = props => {
    const { t } = useTranslation();
    const { open, onClose, onOpenEditModal, data } = props

    return (
        <Dialog className="dialog" open={open} onClose={onClose} fullWidth>
            <DialogTitle disableTypography style={{padding: '32px 32px 20px'}}>
                <Grid container justify="space-between" alignItems="center">
                    <Typography style={{fontSize: '20px'}}>{t('purchase_note')}</Typography>
                    <CloseIcon className="dialog-close" onClick={onClose} />
                </Grid>
            </DialogTitle>
            <div className="d-flex align-items-center" style={{ margin: '15px 0 12px 0' }}>
                <div style={{ height: '1px', width: '100%', backgroundColor: 'rgba(74, 79, 85, 0.1)' }}></div>
            </div>
            <DialogContent>
                <Grid container alignItems="center" style={{ marginBottom: '10px' }}>
                    <Grid item xs={3}>
                        <Typography className="text-grey text-center" >
                            {t('unit_price')}
                        </Typography>
                    </Grid>
                    <Grid item container xs={9}>
                        <Typography style={{marginRight: '25px'}}>{data.currencyRaw}</Typography>
                        <Typography>{formatNumber(data.unitCostRaw)}</Typography>
                    </Grid>
                </Grid>
                <Grid container alignItems="center" style={{ marginBottom: '10px' }}>
                    <Grid item xs={3}>
                        <Typography className="text-grey text-center">
                            {t('purchase_note')}
                        </Typography>
                    </Grid>
                    <Grid item xs={9} container>
                        <Typography>{props.note}</Typography>
                    </Grid>
                </Grid>
            </DialogContent>
            <div className="d-flex align-items-center" style={{ margin: '0px 0 12px 0' }}>
                <div style={{ height: '1px', width: '100%', backgroundColor: 'rgba(74, 79, 85, 0.1)' }}></div>
            </div>
            <DialogActions className="dialog-func">
                <Grid container justify="flex-end" alignItems="center">
                    <Button color="primary" variant="contained" onClick={onOpenEditModal}>
                        {t('edit')}
                    </Button>
                </Grid>
            </DialogActions>
        </Dialog>
  )
}

export default ViewWineNoteDialog